
<template>
    <div>
            <div class="material-line row no-wrap">
                <div class="botton expand-button">
                    <q-btn flat @click="showNomenkl"> 
                        <q-icon name="chevron_right" v-if="!nomenklVisible" />
                        <q-icon name="expand_more" v-if="nomenklVisible" />
                    </q-btn>
                    <q-btn icon="edit" flat class="material-button" color='primary' @click='editMaterial'/>
                    <q-btn icon="delete_outline" flat class="material-button" color='red-8' @click="deleteMaterial" />
                </div>
                <div class="name-container ellipsis">
                    {{material.name}}
                </div>
                <div class="direction-container ellipsis">
                    широкоформатная печать
                </div>
                <div class="post-container ellipsis">
                    <span v-for="p in postList" :key=p.id>
                        <img :src="'/static/'+p.icon" class="post-icon">
                    </span>
                </div>
            </div>

            <q-slide-transition appear :duration=200>
                <div v-show="nomenklVisible" class="nomenkl-container">
                    <nomenklatura-line 
                            :material='null' 
                            :newLine='false'
                    />
                    <div v-for="n in nomenklaturaList" :key=n.id>
                        <nomenklatura-line 
                            :material='n'
                            :newLine='false'
                        />
                    </div>

                    <div v-if="addNew">
                    <nomenklatura-line 
                            :material='{id:-1, type_id:material.id}'
                            :newLine='true'
                        />
                    </div>

                    <q-btn color="positive" icon="add" style="margin-top:15px;" size='sm' @click="addNewNomenklatura">добавить новый</q-btn>
                </div>
            </q-slide-transition>
            
    </div>
</template>

<script>
/* eslint-disable */
export default {
    name : "materialLine",

    props : {
        material : {
            type: Object,
            requered: true,
        }
    },

    created() {
        eventBus.$on('nomenklVisible', (type_id)=>{             // скрываем текущий список (если открыт), когда раскрываем другой список
            if (type_id != this.material.id) this.nomenklVisible = false;
        });

        eventBus.$on('hideNewLine', ()=> {
            this.addNew = false;
        });

    },

    beforeDestroy() {
        eventBus.$off('nomenklVisible');
        eventBus.$off('hideNewLine');
    },

    components :{
        'nomenklaturaLine' : () => import('./materialLineNomenklatura.vue'),
    },

    data () {
            return {
                nomenklVisible : false,
                loading : false,
                addNew : false,
            }
    },
    methods : {
        addNewNomenklatura(){
            this.addNew = true;
        },
        editMaterial() {
            eventBus.$emit('showEditMaterialDialog', this.material.id)
        },

        showNomenkl() {
            eventBus.$emit('nomenklVisible', this.material.id);
            this.nomenklVisible = !this.nomenklVisible;
        },
        
        deleteMaterial() {
            // надо для начала спросить удалять или нет
            this.$q.dialog({
                title:'Внимание!',
                message: 'Подтвердите удаление материала '+this.material.name,
                color : 'primary',
                ok:'Удалить',
                cancel:'Отмена'
            })
            .then( () => {
                this.$store.dispatch('deleteMaterial', this.material.id)
                .then(()=>{
                    this.$admns.showNotify('Запись успешно удалена','success','сообщение системы')
                })
                .catch( ()=> {
                    this.$admns.showNotify('Ошибка при удалении записи','error','сообщение системы')
                });
            })
            .catch(()=>{

            });
        },
    },

    computed : {
        
        postList() { // возвращает допустимые для этого элемента виды обработки

            var result = [];
            var list = [];
            if (this.$store.getters.getAllPostTypes != undefined) { // получаем весь список типов обработки
                list = this.$store.getters.getAllPostTypes; 
            }
            list.forEach(item => {
                if ( this.material.post_types.indexOf(item.id) > -1) { // Ходим по всем типа обработки.. и смотрим есть ли каждая из них в допустимых текущего материала
                    result.push(item);
                }
            });
            return result;
        },

        nomenklaturaList(){
            return this.$store.getters.getNomenklaturaByType(this.material.id);
        }

    },
    

}
</script>

<style lang="scss" scoped>

.material-line{
    width : 100%;
    border: 1px solid rgb(194, 194, 194);
    font-family: Arial, Helvetica, sans-serif;
    font-size:14px;
    padding: 0;
    background: rgb(238, 238, 238);
    margin-bottom: -1px;
    min-height:38px;
    cursor : default;
    &:hover {
        background : rgb(225, 252, 225);
    }
}
.nomenkl-container {
    background: rgb(207, 210, 255);
    width : 100%;
    height: auto;
    min-height: 10px;
    text-align: center;
    border :1px solid rgb(194, 194, 194);
    margin-bottom : 0px;
    padding : 10px;
}
.material-button {
    width : 30px;
}
.name-container {
    padding: 9px;
    width:20%;
}
.direction-container {
    padding : 9px;
}
.post-type-container {
    padding : 9px;
    text-align: right;
    width : 100%;
}
.post-icon {
    width: 33px;
    margin-left : 5px;
}
</style>
